import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStatusFailed = createIcon({
  viewBox: '0 0 48 48',
  path: (
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g transform="translate(-1771 -171) translate(1444 143) translate(242) translate(85 28)">
                <circle
                  cx="24"
                  cy="24"
                  r="16.125"
                  fill="#D33"
                  stroke="#FFF"
                  strokeWidth="3.75"
                />
                <circle
                  cx="24"
                  cy="24"
                  r="17.25"
                  stroke="#D33"
                  strokeWidth="1.5"
                />
              </g>
              <path
                fill="#FFF"
                d="M25.619 24l4.046-4.046c.447-.447.447-1.172 0-1.619-.447-.447-1.172-.447-1.619 0L24 22.381l-4.046-4.046c-.447-.447-1.172-.447-1.619 0-.447.447-.447 1.172 0 1.619L22.381 24l-4.046 4.046c-.447.447-.447 1.172 0 1.619.447.447 1.172.447 1.619 0L24 25.619l4.046 4.046c.447.447 1.172.447 1.619 0 .447-.447.447-1.172 0-1.619L25.619 24z"
                transform="translate(-1771 -171) translate(1444 143) translate(242) translate(85 28)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  ),
});

export default IconStatusFailed;
